import { useEffect } from "react";
import { FlexGrid, Typography, useThemeProvider, Card, Skeleton, Separator, Button, useDialog } from '@albo-ui/core'
import { CustomerFeaturesProps } from "./types";
import { useBenefitsTable } from "./hooks/useBenefitsTable";
import { useBenefitsUpdate } from "./hooks/useBenefitsUpdate";
import DataTable from "react-data-table-component";
import { customStyles2 } from "../../../util/TableStyles"
import { noDataComponent } from "../../../util/DataObject"
import { paginationComponentOptions } from "../../../util/i18n-es";
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import { Tabs, Tab, Box } from "@mui/material";
import useExpandableHistory from "./hooks/useExpandableHistory";
import { FeatureCustomerAdd } from "../../modals/feature-admin/FeatureCustomerAdd";

export const FeatureCustomerGet = ({ changeAlert, changeLoader, sectionData }: CustomerFeaturesProps) => {
    const { theme } = useThemeProvider();
    const { loading: loadingUpdate, removeFeature, addFeature, DialogConfirm, getCustomerData, handleGet } = useBenefitsUpdate(changeAlert)
    const { columns, data, loading: loadingTable, uuid, tabs, tabActive, findActiveTab, changeTab, saveData, getData } = useBenefitsTable(changeAlert, removeFeature )
    const dialogProps = useDialog();

    const onOpenAddFeature = () => {
        dialogProps.openDialog();
    };
    const onCloseDialogCustomer = () => {
        dialogProps.onClose();
    };
    const onAddFeature = async (data: any) => {
        dialogProps.onClose();
        addFeature(data);
    };

    useEffect(() => {
        changeLoader(loadingTable)
        if(!loadingTable){
            handleGet(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable])

    useEffect(() => {
       saveData(sectionData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
        changeLoader(loadingUpdate)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingUpdate])
    useEffect(() => {
        if(getCustomerData){
            getData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getCustomerData])
    
    return (
        <Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: theme.colors.manatee }}> 
            <FlexGrid container fullWidth justify="space-between" style={{ margin: '25px 0' }}>
                <FlexGrid container fullWidth justify="space-between" style={{ display: "block" }}>
                    <FlexGrid item>
                        <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
                            <LocalActivityIcon sx={{ marginRight: 1 }}/> Beneficios del Cliente
                        </Typography>
                    </FlexGrid>
                    <FlexGrid item style={{marginTop: 8}}>
                        <Typography variant="paragraph">{uuid}</Typography>
                    </FlexGrid>
                </FlexGrid>

                <FlexGrid item>
                    <Button onClick={onOpenAddFeature.bind(this)} buttonType='secondary' size='normal' style={{width: 110}}>Agregar</Button>
                </FlexGrid>
            </FlexGrid>

            <Box sx={{ borderBottom: 1, borderColor: "divider" }} mb={2}>
                <Tabs value={tabs.findIndex(findActiveTab)} indicatorColor='secondary' textColor='secondary'>
                    {tabs.map((item, index) => {
                        return (
                            <Tab key={index} label={item.title} onClick={changeTab.bind(this, item.key)} sx={{textTransform: "none", fontWeight: 700, fontFamily: "Muli,sans-serif", fontSize: 18,}}/>
                        );
                    })}
                </Tabs>
            </Box>
                    
            { data?.length === 0 && <Separator orientation="horizontal" style={{minHeight: 4, maxHeight: 4}} />}
            <FlexGrid container spacing={2} style={{margin: '25px 0' }}>
                {
                    loadingTable ?
                        <Skeleton width="100%" height="100px" />
                        :
                        <DataTable
                            columns={columns}
                            data={data[tabActive]}
                            customStyles={customStyles2}
                            noDataComponent={noDataComponent}
                            progressPending={loadingTable}
                            paginationComponentOptions={paginationComponentOptions}
                            expandableRows={tabActive === 'blacklist' ? true : false}
                            expandableRowsComponent={useExpandableHistory.bind(this)}
                        />
                }
            </FlexGrid>
            <DialogConfirm />
            <FeatureCustomerAdd
                title={"Agregar beneficio"}
                open={dialogProps.open}
                onClose={onCloseDialogCustomer}
                onConfirm={onAddFeature.bind(this)}
                changeAlert={changeAlert}
                changeLoader={changeLoader}
                customer={uuid}
            />
        </Card>
    )
}

